//import Libraries
import React, {Component} from 'react';
import {connect} from 'react-redux';

//import Components
import Order from './Order';
import * as ordersActions from './actions/ordersAction';

import { Table } from 'reactstrap';

//import Styles

import './OrderTable.css';
import './Order.css';

class OrderTable extends Component {

    constructor(props) {
        super(props);

        const {orders} = props;

        this.state = {
            allChecked : false,
            checked : new Array(orders.length).fill(false)
        }
    }

    compareCheckedArray = (arr1, arr2) => {
        if(arr1.length !== arr2.length) {
            return false;
        }

        for(let i = 0; i < arr1.length; ++i) {
            if(arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if(prevProps.orders.length != this.props.orders.length) {
            this.setState({
                checked : new Array(this.props.orders.length).fill(false)
            })
            return;
        }

        if(!this.compareCheckedArray(prevState.checked, this.state.checked) ) {
            let ids = [];
            this.state.checked.map((check, index) => {
                if(check) {
                    ids.push(this.props.orders[index].id);
                }
            })    
            this.props.onUpdateCheckedOrders(ids);
        }
    }

    handleOnCheckboxChange = (e) => {
        const checked = e.target.checked;
        let checkedState = [...this.state.checked];
        let allChecked = true;
        if(e.target.name.includes('parent')) {
            checkedState.fill(checked);
            allChecked = checked;
        } else {
            const index = parseInt(e.target.name);
            checkedState[index] = checked;
            checkedState.forEach(element => {
                if (element === false) {
                    allChecked = false;
                }
            })
        }
        this.setState({
            checked: checkedState,
            allChecked
        })
    }

    render() {
        const {orders, accounts, products} = this.props;

        return (
            <Table responsive className="OrderTable">
                <thead>
                    <tr>
                        <th>
                            <input type="checkbox" name="check-parent" onChange={this.handleOnCheckboxChange} checked={this.state.allChecked} />
                        </th>
                        <th>주문자명</th>
                        <th>소속</th>
                        <th>주문시간</th>
                        <th>주문상품</th>
                        <th>주문수량</th>
                        <th>상태</th>
                        <th>메세지</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        orders.map((order, index) => {
                            const { uid } = order;
                            const accountMatchIndex = accounts.findIndex(account => {
                                return account.uid === uid;
                            })

                            const account = accountMatchIndex === -1 ? undefined : accounts[accountMatchIndex];
                            if(account !== undefined){
                                return (
                                    <Order
                                        order={order}
                                        account={account}
                                        products={products}
                                         checked={ this.state.checked[index] }
                                        handleOnChange={this.handleOnCheckboxChange}
                                        index={index}
                                        key={index} />
                                );
                            }else{
                                return
                            }
                        })
                    }
                </tbody>
            </Table>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateCheckedOrders : (ids) => {
            dispatch(ordersActions.updateCheckedOrders(ids))
        }
    }
}

export default connect(null, mapDispatchToProps)(OrderTable);


// WEBPACK FOOTER //
// ./src/pages/Admin/OrderManager/OrderTable.js